export default __webpack_public_path__ + "static/media/close.224c1fc1.svg";